import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Main } from 'Containers/';
import { TitledCard, NotificationMessage } from 'Components/';
import { errorToast } from 'Common/ToastHelper';

import * as PowerSchoolExportSelectors from '../../state/selectors';
import * as PowerSchoolExportActions from '../../state/actions';

class PowerSchoolExportExportStepContainer extends Component {
  static stepInfo = {
    icon: 'file text',
    title: 'Manual Export',
    description: 'Export your data',
  };

  componentDidUpdate(prevProps) {
    const {
      postExportResult,
      postExportErrors,
      clearPostExportResult,

      setStepCompleted,
    } = this.props;

    if (postExportResult || postExportErrors) {
      if (!errorToast(this.props, prevProps, 'postExportErrors')) {
        NotificationMessage({ Data: postExportResult, Errors: [] });
        setStepCompleted(true);
      }

      clearPostExportResult();
    }
  }

  getMainProps = () => {
    const {
      goToPreviousStep,
      postExportLoading,
      postExport,
      stepCompleted,
    } = this.props;

    const mainProps = {
      toolbox: {
        shown: true,
        backButtonProps: {
          shown: true,
          callback: goToPreviousStep,
          disabled: postExportLoading,
        },
        rightButtons: [
          {
            content: 'Export',
            loading: postExportLoading,
            disabled: postExportLoading || stepCompleted,
            onClick: () => postExport(),
          },
        ],
      },
    };

    return mainProps;
  };

  render() {
    const mainProps = this.getMainProps();

    return (
      <Main {...mainProps}>
        <TitledCard title="Manual Export">
          <p>
            Running manual export will create a new file with the given filename
            in your SFTP directory, overwriting the previous file if it exists.
          </p>
        </TitledCard>
      </Main>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    postExportLoading: PowerSchoolExportSelectors.postExportLoading(state),
    postExportResult: PowerSchoolExportSelectors.postExportResult(state),
    postExportErrors: PowerSchoolExportSelectors.postExportErrors(state),
  };
};

const mapDispatchToProps = {
  postExport: PowerSchoolExportActions.postExport,
  clearPostExportResult: PowerSchoolExportActions.clearPostExportResult,
};

export const PowerSchoolExportExportStep = connect(
  mapStateToProps,
  mapDispatchToProps
)(PowerSchoolExportExportStepContainer);



// WEBPACK FOOTER //
// ./src/pages/powerschoolintegration/powerschoolexport/components/PowerSchoolExportExportStep/PowerSchoolExportExportStep.js